import Splide from '@splidejs/splide';

function banner() {

    // console.log('Banner block loaded');

    // Initialize all banner carousels
    const carouselElements = document.querySelectorAll('[data-banner-carousel]');
    
    carouselElements.forEach(carouselElement => {

        // console.log('Initializing banner carousel', carouselElement);

        const splide = new Splide(carouselElement, {
            type: 'fade',
            rewind: true,
            autoplay: true,
            interval: 4000,
            speed: 1500,
            arrows: false,
            pagination: false,
            pauseOnHover: false,
            pauseOnFocus: false,
            resetProgress: false,
            height: '100%',
        });

        splide.mount();
    });
}

export default banner;